'use client';

import React from "react";
import { track } from "@lib/track";

interface FaqItem {
  q: string;
  a: React.ReactNode;
  trackLabel: string;
}

interface FaqAccordionProps {
  faqs: FaqItem[];
}

export default function FaqAccordion({ faqs }: FaqAccordionProps) {
  return (
    <div className="flex flex-col gap-4">
      {faqs.map((faq) => (
        <details
          key={faq.q}
          className="group rounded-2xl overflow-hidden transition-shadow open:shadow-md"
          style={{
            background: "var(--bg-surface)",
            border: "1px solid var(--border-on-light)",
          }}
          onToggle={(e) => {
            const el = e.currentTarget;
            if (el.open) {
              track(
                "accordion_toggle",
                { label: faq.trackLabel, component: "FAQSection" },
                { event: "accordion_toggle", label: faq.trackLabel, component: "FAQSection" }
              );
            }
          }}
        >
          <summary
            className="cursor-pointer px-6 py-5 font-medium text-[0.97rem] flex justify-between items-center gap-4 list-none [&::-webkit-details-marker]:hidden"
            style={{ color: "var(--text-on-light)" }}
          >
            {faq.q}
            <span
              className="text-[1.2rem] font-light flex-shrink-0 transition-transform duration-300 group-open:rotate-45"
              style={{ color: "var(--text-brand)" }}
            >
              +
            </span>
          </summary>
          <div
            className="px-6 pb-6 pt-4 text-[0.92rem] leading-[1.75]"
            style={{
              borderTop: "1px solid var(--border-on-light)",
              color: "var(--text-on-light-muted)",
            }}
          >
            {faq.a}
          </div>
        </details>
      ))}
    </div>
  );
}
